import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet-routing-machine";
import { getPostajaIcon } from "./tmp/icons";

function Routing({ coords, postaja }) {
  const map = useMap();

  useEffect(() => {
    if (!map || !coords || !postaja) return;

    const control = L.Routing.control({
      waypoints: [
        L.latLng(coords.latitude, coords.longitude),
        L.latLng(postaja.long, postaja.lat)
      ],
      createMarker: (i, waypoint) => {
        if (i === 1) {
          return L.marker(waypoint.latLng, {
            icon: getPostajaIcon(postaja, true)
          });
        }
        return L.marker(waypoint.latLng);
      },
      router: new L.Routing.OSRMv1({
        serviceUrl: import.meta.env.VITE_OSRM
      }),
      lineOptions: {
        styles: [{ color: "blue", opacity: 0.6, weight: 4 }]
      },
      addWaypoints: false,
      draggableWaypoints: false,
      showAlternatives: false,
      show: false
    }).addTo(map);

    return () => {
      map.removeControl(control);
    };
  }, [map, coords, postaja]);

  return null;
}

export default Routing;

export function getDistanceAndTimeOfTwoLocations(
  postaja,
  userCoords,
  map,
  routesfoundCallback
) {
  const control = L.Routing.control({
    waypoints: [
      L.latLng(postaja.long, postaja.lat),
      L.latLng(userCoords.lat, userCoords.lng)
    ],
    router: new L.Routing.OSRMv1({
      serviceUrl: import.meta.env.VITE_OSRM
    })
  });
  control.addTo(map);
  control.on("routesfound", routesfoundCallback);
  control.route();
}
